import React, { isValidElement, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from '../../utils/classNames';
import Icon from '../../Icon';
import AlignToText from '../../AlignToText';

var Selection = function Selection(_ref) {
  var qa = _ref.qa,
      className = _ref.className,
      selected = _ref.selected,
      primaryText = _ref.primaryText,
      alert = _ref.alert,
      disabled = _ref.disabled,
      iconType = _ref.iconType;
  var icon = selected ? 'check' : 'spacer';
  icon = iconType || icon;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, 'psw-fill-x', 'psw-l-line-left')
  }, /*#__PURE__*/React.createElement(AlignToText, {
    fontStyle: "body",
    spacer: /*#__PURE__*/React.createElement("div", {
      className: "psw-l-w-icon-3 psw-m-r-3"
    }),
    position: "center-left"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classNames(disabled && 'psw-c-t-disabled', selected && !iconType && 'psw-c-t-accent'),
    qa: "".concat(qa, "#").concat(icon),
    size: "3",
    type: icon
  })), /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#primaryText"),
    className: classNames('psw-t-truncate-1', 'psw-t-body', 'psw-p-y-1', !!alert && 'psw-m-r-4')
  }, primaryText), !!alert && /*#__PURE__*/isValidElement(alert) && /*#__PURE__*/cloneElement(alert, {
    qa: "".concat(qa, "#alert")
  }));
};

Selection.defaultProps = {
  qa: '',
  className: '',
  selected: false,
  disabled: false,
  alert: null,
  iconType: ''
};
Selection.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * whether the option is selected or not
   */
  selected: PropTypes.bool,

  /**
   * Whether the option is disabled or not
   */
  disabled: PropTypes.bool,

  /*
   * The Alert component
   */
  alert: PropTypes.node,

  /**
   * The primary text label for the option
   */
  primaryText: PropTypes.string.isRequired,

  /**
    * String of the icon type to be shown in the cta
    */
  iconType: PropTypes.string
};
export default Selection;